import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from "./components/Hero";
import Parallax from "./components/parallax/Parallax";
import Services from "./components/services/Services";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import HorizontalText from "./components/HorizontalText/HorizontalText";

function HomePage() {
    return (
        <div>
            <section id="Homepage">
                <Hero/>
            </section>
            <section id="Services">
                <Parallax type="services"/>
            </section>
            <section>
                <Services/>
            </section>
            <section id="Portfolio">
                <Parallax type="portfolio"/>
            </section>
                <Portfolio/>
            <section id="Contact">
                <Contact/>
            </section>
        </div>
    );
}

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/horizontal-text" element={<HorizontalText />} />
            </Routes>
        </Router>
    );
}

export default App;
